import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Location as routerLocation } from '@angular/common';
import { RouteDetailComponent } from './route-detail/route-detail.component';
import { RouteService } from 'app/services/routes/route.service';
import { Route } from 'app/models/route.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-routes',
  templateUrl: './routes.component.html',
  styleUrls: ['./routes.component.css']
})
export class RoutesComponent implements OnInit {

  domainId: number;
  routes: Route[] = [];
  route: Route;
  routesDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) routesPaginator: MatPaginator;
  @ViewChild(MatSort) routesSort: MatSort;
  routesDisplayedColumns: string[] = ['description', 'locationsQty', 'actions']
  constructor(private dialog: MatDialog,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private navigate: routerLocation,
    private routeService: RouteService) { }

  async ngOnInit() {
    this.domainId = this.activatedRouter.snapshot.params.id;
    // this.routeService.getRoutes(this.domainId).subscribe((result) => {
    //   console.log('cargando rutas...');
    //   this.routes = result;
    //   this.routesDataSource = new MatTableDataSource<any>(this.routes);
    // })
    
  }

  async ngAfterViewInit() {
    this.routes = await this.routeService.getRoutes(this.domainId);
    this.routesDataSource = new MatTableDataSource<any>(this.routes);
    this.routesDataSource.paginator = this.routesPaginator;
    this.routesDataSource.sort = this.routesSort;
  }

  openRoutesForm(routeId?){
    if(!routeId){
      this.router.navigateByUrl(`dashboard/domains/${this.domainId}/route-detail/`);
    }else{
      this.router.navigateByUrl(`dashboard/domains/${this.domainId}/route-detail/${routeId}`);
    }
  }

  // openRoutesForm(){
  //   const dialogRef = this.dialog.open(RouteDetailComponent, {
  //     width: '900px',
  //     height: '700px',
  //     disableClose: true,
  //     data: {
  //       domainId: this.domainId
  //     }
  //   });

  //   dialogRef.afterClosed().subscribe(res => {
  //     console.log('routesFrom closed');
  //     this.ngOnInit();
  //   })
  //   // this.router.navigateByUrl('/route');
  // }

  updateRoute(route: Route){
    this.route = route;
    this.openRoutesForm(this.route.id);
  }

  navigateBack(){
    this.navigate.back();
  }

}
